const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Get content models', () => {
  describe('get content types', () => {
    const mock = loadRecordedMock('get_contenttypes_preview.json');

    it(`should return ${mock.response.length} content types`, (done) => {
      migratortronApi.post(
        'get/contenttypes',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          if (body.error) done(body.error);
          // console.log(JSON.stringify(body), body);

          const contentTypes = Array.isArray(body) && body;
          expect(contentTypes?.length).to.be.greaterThan(0);
          done(error);
        }
      );
    });
  });

  describe('return components', () => {
    const mock = loadRecordedMock('get_components_preview.json');

    it(`should return ${mock.response.length} components`, (done) => {
      migratortronApi.post(
        'get/components',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          if (body.error) done(body.error);

          const components = Array.isArray(body) && body;
          expect(components?.length).to.be.greaterThan(0);
          done();
        }
      );
    });
  });

  describe('return models', () => {
    const mock = loadRecordedMock('get_models_preview.json');

    it(`should return ${mock.response.length} models`, (done) => {
      migratortronApi.post(
        'get/models',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          if (body.error) done(body.error);

          const models = Array.isArray(body) && body;
          expect(models?.length).to.be.greaterThan(0);
          expect(models?.length).to.be.equal(mock.response.length);
          done(error);
        }
      );
    });
  });

  describe('diff models', () => {
    const mock = loadRecordedMock('diff_preview.json');
    const updateContentTypes = jpath(
      "contentTypes.*.projects.[?(@.status === 'update')]",
      mock.response
    );
    const updateComponents = jpath(
      "components.*.projects.[?(@.status === 'update')]",
      mock.response
    );

    it(`should find differences in ${updateContentTypes?.length} content types and ${updateComponents?.length} components`, (done) => {
      migratortronApi.post(
        'diff',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          // console.log(JSON.stringify(body), body);
          const contentTypes = body?.contentTypes;
          const components = body?.components;
          const updatedContentTypes = jpath(
            "*.projects.[?(@.status === 'update')]",
            body?.contentTypes || {}
          );
          const updatedComponents = jpath(
            "*.projects.[?(@.status === 'update')]",
            body?.components || {}
          );

          expect(updatedContentTypes?.length).to.be.greaterThan(0);
          expect(updatedComponents?.length).to.be.equal(0);

          expect(Object.keys(contentTypes)?.length).to.be.equal(
            Object.keys(mock.response.contentTypes)?.length
          );
          expect(Object.keys(components)?.length).to.be.equal(
            Object.keys(mock.response.components)?.length
          );

          done();
        }
      );
    });
  });
});
